import { useEffect, useState } from "react";
import {
    StyledHeader, Logo, StyledHeaderInner,
    HeaderMenu, HeaderMenuItem, MenuToggle
} from "./styles/common.styled";
import { Container, useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import { PROMO_CODE } from "../config";
import { PhoneNumbers } from "./data";

export const Header = () => {
    const [showMenu, setShowMenu] = useState(false);
    const [promoCode, setPromoCode] = useState("");
    const location = useLocation();
    const isMobile = useMediaQuery('(max-width: 768px)');
    
    useEffect(() => {
        setPromoCode(location.pathname.substring(1) as string || PROMO_CODE);
    }, [])
    return (
        <StyledHeader>
            <Container>
                <StyledHeaderInner>
                    <Logo href="/">
                        <img src="/images/logo.png" alt="" />
                        {/* <img src="/images/constellation-tagline.png" alt=""/> */}
                    </Logo>

                    <MenuToggle
                        active={`${showMenu}`}
                        onClick={() => {
                            if (showMenu) {
                                document.body.style.overflow = 'unset'
                            }
                            else {
                                document.body.style.overflow = 'hidden'
                            }
                            setShowMenu(!showMenu)
                        }}
                    />
                    <HeaderMenu active={`${showMenu}`}>
                        <HeaderMenuItem href={`tel:${PhoneNumbers[promoCode]}`}>
                            Contact Us Today! {!isMobile && PhoneNumbers[promoCode]}
                        </HeaderMenuItem>
                    </HeaderMenu>
                </StyledHeaderInner>
            </Container>
        </StyledHeader>
    )
}